<div class="dialogue-content">
  <div class="mat-dialogue-header">
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title" *ngIf="this.IsPreviewTrue && !this.isEditing">
      {{LabelConstants.UserPreview}}</h4>
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title" *ngIf="!this.IsPreviewTrue && !this.isEditing">
      {{LabelConstants.AddUser}}</h4>
    <h4 class="mat-dialog-title previewHeading" id="modal-basic-title" *ngIf="!this.IsPreviewTrue && this.isEditing">
      {{LabelConstants.EditUser}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  <mat-dialog-content class="">
    <div class="main-form">
      <form [formGroup]="AddUserForm" (ngSubmit)="submitUserForm()" novalidate>

        <!-- User Image -->
        <div class="row">
          <div class="col-lg-3 col-sm-6 col-12 mb-2">
            <div class="position-relative upload-btn">
              <img (error)="handleImageError()"
                [src]="imageSrc ? imageSrc : '../../../assets/img/default-user-profile.svg'" class="me-2 profile-image"
                alt="User Image" width="135" height="135" />
              <label for="uplaod-btn"><img src="../../../../assets/img/img-icon.svg" class="img-icon" alt=""
                  *ngIf="!IsPreviewTrue" /></label>
              <input type="file" (change)="onFileSelected($event)" formControlName="UserImage" id="uplaod-btn"
                accept="image/*" />
            </div>
          </div>
        </div>

        <!-- Firstname / Lastname -->
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="mb-3">
              <mat-label> {{LabelConstants.FirstName}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput formControlName="FirstName" oninput="this.value = this.value.replace(/^\s+/g, '')"
                  type="text" maxlength="49" placeholder="Enter First Name" />
              </mat-form-field>
              <mat-error *ngIf="
              submitted && AddUserForm.get('FirstName').hasError('required')">
                {{ ErrorMessages.FirstNameRequired }}
              </mat-error>
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.LastName}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput formControlName="LastName" oninput="this.value = this.value.replace(/^\s+/g, '')"
                  type="text" maxlength="49" placeholder="Enter Last Name" />
              </mat-form-field>
              <mat-error *ngIf="
              submitted && AddUserForm.get('LastName').hasError('required')">
                {{ ErrorMessages.LastNameIsRequired }}
              </mat-error>
            </div>
          </div>
        </div>

        <!-- Role -->
        <div class="row">
          <div class="col-sm-12 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.Role}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100">
                <mat-select [ngClass]="{'preview-mode': IsPreviewTrue}" formControlName="Role" id="style"
                  placeholder="Select Role" #singleSelect>
                  <mat-option>
                    <ngx-mat-select-search placeholderLabel="Search Role..." noEntriesFoundLabel="No such role found."
                      [formControl]="RoleCtrl"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option panelClass="search-top" *ngFor="let role of FilteredRole | async" [value]="role.id">
                    {{role.value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-error *ngIf="submitted && AddUserForm.get('Role').hasError('required')">
                {{ ErrorMessages.RoleNameRequired }}
              </mat-error>
            </div>
          </div>
        </div>

        <!-- Email/PhoneNo -->
        <div class="row">
          <div class="col-sm-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.Email}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput formControlName="Email" oninput="this.value = this.value.trimStart().toLowerCase()"
                  maxlength="99" placeholder="Enter Email" />
              </mat-form-field>
              <mat-error *ngIf="submitted && AddUserForm.get('Email').hasError('required')">
                {{ ErrorMessages.EmalRequired }}
              </mat-error>
              <mat-error *ngIf="submitted && GetUserFormControls['Email'].errors?.['pattern']">
                {{ ErrorMessages.EmailNotValid }}
              </mat-error>
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.PhoneNumber}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput formControlName="PhoneNumber"
                  oninput="this.value = this.value.replace(/^\s+|\D+/g, '').substring(0, 15)"
                  placeholder="Enter Phone Number" />
              </mat-form-field>
              <mat-error *ngIf="
              submitted && AddUserForm.get('PhoneNumber').hasError('required')">
                {{ ErrorMessages.PhoneNoRequired }}
              </mat-error>
              <mat-error *ngIf="submitted && GetUserFormControls['PhoneNumber'].errors?.['minlength']">
                {{ErrorMessages.PhoneNumberNotValid}}
              </mat-error>
            </div>
          </div>
        </div>

        <!-- Address -->
        <div class="row">
          <div class="col-sm-12 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.AddressL1}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput formControlName="Address" oninput="this.value = this.value.replace(/^\s+/g, '')"
                  type="text" maxlength="100" placeholder="Enter Address Line 1" />
              </mat-form-field>
              <mat-error *ngIf="
              submitted && AddUserForm.get('Address').hasError('required')">
                {{ ErrorMessages.AddressRequired }}
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-12">  
            <div class="mb-3">
              <mat-label>{{LabelConstants.State}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput formControlName="State" oninput="this.value = this.value.replace(/^\s+/g, '')"
                  type="text" maxlength="100" placeholder="Enter Address Line 2" />
              </mat-form-field>
              <mat-error *ngIf="submitted && AddUserForm.get('State').hasError('required')">
                {{ ErrorMessages.StateRequired }}
              </mat-error>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.PostalCode}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field style="width: 100%" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput formControlName="PostalCode"
                  oninput="this.value = this.value.replace(/[^a-zA-Z0-9\s]+/g,'').substring(0, 8)"
                  (input)="isZipCodeValid($event.target.value)" placeholder="Enter Postal Code" maxlength="8" />
              </mat-form-field>
              <mat-error *ngIf="
              submitted && AddUserForm.get('PostalCode').hasError('required')
            ">
                {{ ErrorMessages.PostcodeRequired }}
              </mat-error>
              <mat-error *ngIf="submitted && GetUserFormControls['PostalCode'].errors?.['minlength']">
                {{ErrorMessages.PostalNotValid}}
              </mat-error>
              <mat-error
                *ngIf="submitted && !isZipValid && !(GetUserFormControls['PostalCode'].errors?.['required']) && !(GetUserFormControls['PostalCode'].errors?.['minlength'])">
                {{ErrorMessages.PostalNotValid}}
              </mat-error>
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.City}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <input matInput formControlName="City" oninput="this.value = this.value.replace(/^\s+/g, '')"
                  type="text" maxlength="50" placeholder="Enter Town/City" />
              </mat-form-field>
              <mat-error *ngIf="submitted && AddUserForm.get('City').hasError('required')">
                {{ ErrorMessages.CityRequired }}
              </mat-error>
            </div>
          </div>
        </div>

        <!-- Country -->
        <div class="row">
          <div class="col-sm-12 col-12">
            <div class="mb-3">
              <mat-label>{{LabelConstants.Country}}<span *ngIf="!IsPreviewTrue">*</span></mat-label>
              <mat-form-field class="w-100" [ngClass]="{'preview-mode': IsPreviewTrue}">
                <mat-select [ngClass]="{'preview-mode': IsPreviewTrue}" formControlName="Country" id="style"
                  placeholder="Select Country" #singleSelect>
                  <mat-option>
                    <ngx-mat-select-search placeholderLabel="Search Country" noEntriesFoundLabel="No such country found."
                      [formControl]="CountryCtrl"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option panelClass="search-top" *ngFor="let country of FilteredCountry | async" [value]="country.id">
                    {{country.value}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-error *ngIf="
                      submitted && AddUserForm.get('Country').hasError('required')">
                {{ ErrorMessages.CountryRequired }}
              </mat-error>
            </div>
          </div>
        </div>

        <div class="dialogue-footer">
          <button class="btn btn-primary" *ngIf="!IsPreviewTrue && !isEditing" type="submit">
            {{LabelConstants.Add}}
          </button>
          <button class="btn btn-primary" *ngIf="!IsPreviewTrue && isEditing" type="submit">
            {{LabelConstants.Update}}
          </button>
          <button class="btn btn-info" *ngIf="!IsPreviewTrue" (click)="cancel()" type="button">
            {{LabelConstants.Cancel}}
          </button>
        </div>
      </form>
    </div>
  </mat-dialog-content>
</div>